import React from 'react';
import {Collapse as CollapseContainer} from 'react-collapse';
import {useToggle} from 'react-use';
import {animated, useSpring} from 'react-spring';
import {IoIosArrowDown} from 'react-icons/io';

import styles from './collapse.module.scss';

export const Collapse = ({children, title, isOpened = true}) => {
  const [show, setShow] = useToggle(isOpened);

  const spin = useSpring({
    config: {friction: 10},
    transform: show ? 'rotate(180deg)' : 'rotate(0deg)'
  });

  return (
    <div className={styles.container}>
      <div className="py-2 flex justify-between px-4" onClick={() => setShow()} tabIndex={0}>
        <h3 className='font-semibold'>{title}</h3>
        <animated.button style={spin}>
          <IoIosArrowDown/>
        </animated.button>
      </div>
      <CollapseContainer isOpened={show}>
        {children}
      </CollapseContainer>
    </div>
  );
};
